/**
* @Description 文件功能说明：账户组件
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <el-pagination
        :small="small"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pageSize"
        :total="total"
        :pager-count="pagerCount"
        background
        layout="total, sizes, prev, pager, next, jumper"
        class="paginationStyle"
        >
    </el-pagination>
</template>

/* JS */
<script>
    export default {
        /**
			* @Des 组件名
			* @Auth CC
			* @Date 2021/04/30
			*/
        name: "Pagination",

        /**
			* @Des 接收数据
			* @Auth CC
			* @Date 2021/04/30
			*/
        props: {
            /**
			* @Des 页容量
			* @Auth CC
			* @Date 2021/04/30
			*/
            pageSize: {
                type: Number,
                default: 1
            },

            /**
			* @Des 总条数
			* @Auth CC
			* @Date 2021/04/30
			*/
            total: {
                type: Number,
                default: 0
            },

            /**
			* @Des 当前页
			* @Auth CC
			* @Date 2021/04/30
			*/
            currentPage:{
                type: Number,
                default: 1
            },

            /**
			* @Des 总页数
			* @Auth CC
			* @Date 2021/04/30
			*/
            pagerCount:{
                type: Number,
                default: 5
            },

            /**
			* @Des 是否是小尺寸
			* @Auth CC
			* @Date 2021/04/30
			*/
            small:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
            }
        },
        methods: {
            //每页展示条数
            handleSizeChange(val) {
                // console.log(val)
                //事件传递
                this.$emit('handleSizeChangeSub', val);
            },
            //当前页
            handleCurrentChange(val) {
                //事件传递
                // console.log(val)
                this.$emit('handleCurrentChangeSub', val);
            }
        },

    }
</script>

/* CSS */
<style lang="scss" scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue